module.exports = __webpack_public_path__ + "static/img/rowen-smith-Y5kUfZypK7s-unsplash_thumb.c2373c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/rowen-smith-Y5kUfZypK7s-unsplash_thumb.png
// module id = LU6X
// module chunks = 4